const models = [
  { display: "🍎 Sage Basic", value: "gpt-3.5-turbo-1106" },
  { display: "🏆 Sage Premium", value: "gpt-4-1106-preview" },
  { display: "🤖 SageAI", value: "gpt-5" },
];
  
  export default models;